import { z } from 'zod';
/**
 * OrgFunction kind discriminator.
 * - `team`: a group people work in (cross-functional or project-based)
 * - `role`: a job position or special function (a Stelle, e.g. Software
 *   Developer, or an org-wide function like Datenschutzbeauftragter)
 *
 * Lives in this leaf module (no import back to user/department) so it can be
 * shared by both `orgFunction.schema.ts` and `user.schema.ts` without creating a
 * User↔OrgFunction module cycle.
 */ export const OrgFunctionKindSchema = z.enum([
    'team',
    'role'
]);
/**
 * User OrgFunction Ref Schema
 *
 * Lightweight OrgFunction reference for the user-side membership links
 * (`mainRole` / `secondaryRoles`). Deliberately omits `lead` and `department`
 * so it references nothing that leads back to User — this breaks the
 * User↔OrgFunction schema cycle that `ManagerUserSchema` exists to avoid (the
 * full `PopulatedOrgFunctionSchema.lead` references `PopulatedUserSchema`).
 * Mirrors how the former `user.role` was a tiny `{_id, name}` ref.
 */ export const UserOrgFunctionRefSchema = z.object({
    _id: z.string(),
    name: z.string(),
    kind: OrgFunctionKindSchema,
    deletedAt: z.number().optional()
});
/**
 * Which link makes a user hold an OrgFunction: their `mainRole` (the Stelle),
 * one of their `secondaryRoles`, or they `lead` it.
 */ export const OrgFunctionLinkSourceSchema = z.enum([
    'main',
    'secondary',
    'lead'
]);
/** A held OrgFunction ref with the link it is held through. */ export const HeldOrgFunctionRefSchema = UserOrgFunctionRefSchema.extend({
    via: OrgFunctionLinkSourceSchema
});

//# sourceMappingURL=org-function-ref.schema.js.map